import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

// Create Team task API
const teamTaskAPI = createApi({
    reducerPath: "teamTaskAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) =>({
        // Team Task management Endpoints

        // Add Team Tasks 
        addTeamTasks: builder.mutation({
            query: (data) =>({
                url: "/TeamTask/AddTeamTasks",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateTeamTasks: builder.mutation({
            query: (data) =>({
                url: "/TeamTask/UpdateTeamTask",
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
    })
})

// Extract hooks for easy access to various API requests 
export const{
    useAddTeamTasksMutation,
    useUpdateTeamTasksMutation
} = teamTaskAPI;

export default teamTaskAPI;